import { render, staticRenderFns } from "./StayVouchers.vue?vue&type=template&id=16f74f95&"
import script from "./StayVouchers.vue?vue&type=script&lang=js&"
export * from "./StayVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports